import Vue from 'vue';
import Router from 'vue-router';

// Containers
import Full from '@/containers/Full'

import ViewsRouter from '@/views/router'

//auth
import Login from '@/views/auth/Login';
import ForgotPassword from '@/views/auth/ForgotPassword';
import UserRouter from '@/views/user/router';
import ClientRouter from '@/views/client/router';
import MenuRouter from '@/views/menu/router';
import PetsRouter from '@/views/pets/router';
import ClinicRouter from '@/views/clinic/router';
import CategoryRouter from '@/views/category/router';
import PostRouter from '@/views/post/router';
import PolicyRouter from '../views/client/policy/router';
import CountryRouter from '@/views/country/router';
import CarrierRouter from '@/views/carrier/router';
import ManualRouter from '@/views/manual/router';
import CenterRouter from '@/views/center/router';
import PageRouter from '@/views/page/router';
import DiscountRouter from '@/views/discount/router';
import IntegratorRouter from '@/views/integrator/router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: '/grafico',
            component: Full,
            meta: {
                requiresAuth: true,
                label: 'Home'
            },
            children: [
                ViewsRouter,
                UserRouter,
                ClientRouter,
                PetsRouter,
                MenuRouter,
                ClinicRouter,
                CategoryRouter,
                PostRouter,
                PolicyRouter,
                CountryRouter,
                CarrierRouter,
                ManualRouter,
                CenterRouter,
                PageRouter,
                DiscountRouter,
                IntegratorRouter
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/esqueci-senha',
            name: 'forgot-password',
            component: ForgotPassword
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js